import React from "react";
import Modal from "react-bootstrap/Modal";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { InputField } from "../../../../Components/formElements/InputField";
import DataTable from "react-data-table-component";
import { TextAreaField } from "../../../../Components/formElements/TextAreaField";

const QualityInspectionViewModal = ({
  show,
  onHide,
  inspectionType,
  rowData,
}) => {
  const inspection = rowData?.inspectionDetails || {};

  const qualityColumns = [
    {
      name: "Checkpoint Title",
      selector: (row) => row.checkpointTitle,
      wrap: true,
      width: "180px",
    },
    {
      name: "Checkpoint Category",
      selector: (row) => row.checkpointCategory,
      wrap: true,
      width: "180px",
    },
    {
      name: "Checkpoint Motive",
      selector: (row) => row.checkpointMotive,
      wrap: true,
      width: "180px",
    },
    {
      name: "Sampling Size",
      selector: (row) => row.samplingSize,
      width: "120px",
    },
    {
      name: "No. of Samples",
      selector: (row) => row.numberOfSamples,
      width: "130px",
    },
    {
      name: "Description",
      selector: (row) => row.description,
      wrap: true,
      width: "280px",
    },
    {
      name: "Required Result",
      selector: (row) => row.requiredResult,
      wrap: true,
      width: "280px",
    },
    {
      name: "Result",
      cell: (row, index) => (
        <TextAreaField
          className="form-control"
          rows={3}
          placeholder="Enter Result"
          value={row.result || ""}
          disabled={true}
          //  onChange={(e) => handleResultChange(index, e.target.value)}
          style={{ minWidth: "220px", fontSize: "12px" }}
        />
      ),
      width: "260px",
    },
  ];

  return (
    <Modal show={show} onHide={onHide} size="xl" centered keyboard={false}>
      <Modal.Header closeButton style={{ background: "#80aee6" }}>
        <Modal.Title>
          {inspectionType === "physical"
            ? "Physical Verification Details"
            : inspectionType === "specification"
              ? "Specification Check Details"
              : "Quality Check Details"}
        </Modal.Title>
      </Modal.Header>

      <Modal.Body>
        {/* Top Info */}
        <div
          style={{
            border: "1px solid #d6d6d6",
            borderRadius: "8px",
            overflow: "hidden",
            marginBottom: "20px",
          }}
        >
          <table style={{ width: "100%", borderCollapse: "collapse" }}>
            <tbody>
              <tr>
                <td
                  style={{
                    padding: "14px",
                    borderRight: "1px solid #d6d6d6",
                    fontWeight: "600",
                  }}
                >
                  GRN Item : {rowData?.grnItemNr || "--"}
                </td>

                <td
                  style={{
                    padding: "14px",
                    borderRight: "1px solid #d6d6d6",
                    fontWeight: "600",
                  }}
                >
                  Material Code : {rowData?.materialCode || "--"}
                </td>

                <td
                  style={{
                    padding: "14px",
                    fontWeight: "600",
                  }}
                >
                  Quantity : {rowData?.grnQuantity || "--"}
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        {/* Physical */}
        {inspectionType === "physical" && (
          <Row className="mb-4">
            <Col
              xs={12}
              md={6}
              lg={4}
              className="commTopButtonRightLeftPadding"
            >
              <InputField
                label="Packaging Condition"
                value={inspection.packagingCondition || ""}
                disabled
              />
            </Col>

            <Col
              xs={12}
              md={6}
              lg={4}
              className="commTopButtonRightLeftPadding"
            >
              <InputField
                label="Physical Damage"
                value={inspection.physicalDamage || ""}
                disabled
              />
            </Col>

            <Col
              xs={12}
              md={6}
              lg={4}
              className="commTopButtonRightLeftPadding"
            >
              <InputField
                label="Quantity Verified"
                value={inspection.quantityVerified || ""}
                disabled
              />
            </Col>

            <Col
              xs={12}
              md={6}
              lg={4}
              className="commTopButtonRightLeftPadding"
            >
              <InputField
                label="Inspection Remarks"
                value={inspection.inspectionRemarks || ""}
                disabled
              />
            </Col>
          </Row>
        )}

        {/* Specification */}
        {inspectionType === "specification" && (
          <Row className="mb-4">
            <Col
              xs={12}
              md={6}
              lg={4}
              className="commTopButtonRightLeftPadding"
            >
              <InputField
                label="Model Matches PO"
                value={inspection.modelMatchesPo || ""}
                disabled
              />
            </Col>

            <Col
              xs={12}
              md={6}
              lg={4}
              className="commTopButtonRightLeftPadding"
            >
              <InputField
                label="Brand Matches PO"
                value={inspection.brandMatchesPo || ""}
                disabled
              />
            </Col>

            <Col
              xs={12}
              md={6}
              lg={4}
              className="commTopButtonRightLeftPadding"
            >
              <InputField
                label="Size / Grade Match"
                value={inspection.sizeGradeMatch || ""}
                disabled
              />
            </Col>

            <Col
              xs={12}
              md={6}
              lg={4}
              className="commTopButtonRightLeftPadding"
            >
              <InputField
                label="Technical Parameters OK"
                value={inspection.technicalParametersOk || ""}
                disabled
              />
            </Col>
          </Row>
        )}

        {/* Quality Check */}
        {inspectionType === "qualityCheck" && (
          <DataTable
            columns={qualityColumns}
            data={inspection.checkpoints || []}
            pagination
            dense
          />
        )}
      </Modal.Body>

      <Modal.Footer>
        <button className="btn btn-danger" onClick={onHide}>
          Close
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default QualityInspectionViewModal;
